export const COUNTRY = {
  CA: 'CA'
};

export const COUNTRY_CODE = {
  CA: 1
};
